import {
  IconEye as Eye,
  IconFileCheck as FileCheck,
  IconSparkles as Sparkles,
  IconTrendingUp as TrendingUp,
} from "@tabler/icons-react";
import { SectionHeader } from "../shared/SectionHeader";

export function AdvantagesSection({ t }) {
  const icons = [FileCheck, TrendingUp, Eye, Sparkles];

  return (
    <section id="advantages" className="relative py-24 md:py-32">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeader eyebrow={t.advantages.eyebrow} title={t.advantages.title} />
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {t.advantages.items.map((a, i) => {
            const Icon = icons[i];
            return (
              <div
                key={i}
                className="reveal group relative overflow-hidden rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-7 transition-all hover:border-brand"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-soft text-brand transition-transform group-hover:scale-110">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="font-display text-xl font-semibold leading-snug">{a.title}</div>
                <div className="mt-3 text-sm text-muted-foreground leading-relaxed">{a.desc}</div>
                <div className="absolute right-5 top-5 font-mono text-xs text-muted-foreground">
                  /0{i + 1}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
